import { mapGetters } from 'vuex';
import accountAddressUpdate from '@/components/account/account-details/update/account-address-update.vue';
import accountDetailsUpdate from '@/components/account/account-details/update/account-details-update.vue';
import accountUpdatePassword from '@/components/account/account-update-password/account-update-password.vue';
import accountSetPassword from '@/components/account/account-set-password/account-set-password.vue';
import modal from '@/components/generics/modal/modal.vue';

export default {
  props: {
    what: String,
  },
  components: {
    accountAddressUpdate,
    accountDetailsUpdate,
    accountUpdatePassword,
    accountSetPassword,
    modal,
  },
  methods: {
    closeModal() {
      this.$router.go(-1);
    },
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile']),
    noPadding() {
      return this.isLayoutMobile;
    },
    header() {
      switch (this.what) {
        case 'account-detail-password-set':
          return 'Set Password';
        case 'account-detail-password':
          return 'Change Password';
        case 'account-detail-update':
          return 'Change Username';
        default:
          return 'Change Address';
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/account/account-details/modal/account-details-update-modal.js